import gql from 'graphql-tag';

export default gql`
  query printQRCodeItems($itemIds: [ID]!) {
    printQRCodeItems(itemIds: $itemIds) {
      pdfData
    }
  }
`;
